<template>
<div>
  <v-menu v-model="menu" :close-on-content-click="false">
    <template #activator="{ on: menu }">
        <v-btn
            icon
            dark
            v-on="menu"
        >
          <v-icon color="green">add</v-icon>
        </v-btn>
    </template>

    <v-card style="padding:1rem;border: 1px rgba(0,0,0,0.31) solid">
      <v-list-tile-content>
        <v-form style="min-width: 480px;max-width:100%;margin-top:0rem;z-index: 999999" v-model="valid">
                <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="Nazwa korespondencji"
                    required
                ></v-text-field>
                <v-select
                    v-model="selectedUsers"
                    :items="users"
                    :menu-props="{ maxHeight: '400' }"
                    label="Odbiorcy"
                    item-text="name"
                    item-value="id"
                    multiple
                    persistent-hint
                ></v-select>
                <v-text-field
                    style="margin-top: 1rem"
                    v-model="message"
                    :rules="messageRules"
                    label="Wiadomość"
                    required
                ></v-text-field>
        </v-form>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-btn @click="createMessageWithInbox" color="green">Wyślij</v-btn>
      </v-list-tile-action>
    </v-card>
  </v-menu>
</div>
</template>

<script>
export default {
  props:['chatMenager'],
  data(){
    return {
      menu:false,
      valid: false,
      name: '',
      message:'',
      selectedUsers: [],
      messageRules:[
        v => !!v || 'Message is required',
        v => v.length > 0 || 'Message must be more than 0 characters'
      ],
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 64 || 'Name must be less than 10 characters',
        v => v.length > 2 || 'Name must be more than 10 characters'
      ],
    }
  },
  computed: {
    users() {
      return this.$store.state.users.map(user => ({'id': user.id, 'name': `${user.name}  ${user.surname}`}))
    }
  },
  methods:{
    createMessageWithInbox(){
      if(this.valid && this.selectedUsers.length > 0){
        this.chatMenager.newInboxWithMessage(this.name, this.message,this.selectedUsers, this.onSuccess)
      }
    },
    onSuccess(data=null){
      if(data != null) {
        this.$emit('created', data.data)
      }
      this.menu = false
    }
  }
}
</script>

<style scoped>

</style>